import AreYouSureModal from './AreYouSureModal'

export default AreYouSureModal
